import React from "react";
import PassengerTicketSalesTabPanel from "./PassengerTicketSalesTabPanel";

/**
 * Aba Passagens dentro do detalhe do workspace — mesmo painel do console plataforma,
 * com workspace fixo e sem navegação multi-tenant.
 */
export default function WorkspacePassengerSalesTab({ dominioId }) {
  if (!dominioId) return null;
  return <PassengerTicketSalesTabPanel fixedDominioId={dominioId} embedded />;
}
